module.exports = __webpack_public_path__ + "assets/img/choice.8ecfe823.svg";